"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Banner = void 0;
var _icons = require("@ori-ui/icons");
var _mui = require("@ori-ui/mui");
var _imageSizesHelper = require("@ori/image-sizes-helper");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _react = require("react");
var _common = require("../../common");
var _LazyImage = require("../LazyImage");
var _Content = require("./Content");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
const DEFAULT_IMAGE_WIDTH = 80;
const Banner = props => {
  const {
    imageUrl,
    imageWidth = DEFAULT_IMAGE_WIDTH,
    type,
    url
  } = props;
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  const {
    palette
  } = (0, _mui.useTheme)();
  const imageWrapperRef = (0, _react.useRef)(null);
  const [imageWrapperWidth, setImageWrapperWidth] = (0, _react.useState)(0);
  const [imageWrapperHeight, setImageWrapperHeight] = (0, _react.useState)(0);
  const lazyImageRef = (0, _react.useRef)(null);
  const [lazyImageWidth, setLazyImageWidth] = (0, _react.useState)(0);
  const [lazyImageHeight, setLazyImageHeight] = (0, _react.useState)(0);
  const shouldWidthBeLarger = (0, _react.useMemo)(() => imageWrapperWidth > imageWrapperHeight || lazyImageWidth < lazyImageHeight, [imageWrapperHeight, imageWrapperWidth, lazyImageHeight, lazyImageWidth]);
  const setLazyImageDimensions = (0, _react.useCallback)(() => {
    if (lazyImageRef.current) {
      setLazyImageWidth(lazyImageRef.current.offsetWidth);
      setLazyImageHeight(lazyImageRef.current.offsetHeight);
    }
  }, []);
  (0, _react.useLayoutEffect)(() => {
    if (imageWrapperRef.current) {
      setImageWrapperWidth(imageWrapperRef.current.offsetWidth);
      setImageWrapperHeight(imageWrapperRef.current.offsetHeight);
    }
  }, [setLazyImageDimensions]);
  const images = (0, _react.useMemo)(() => imageUrl ? (0, _imageSizesHelper.getImageVariants)({
    url: imageUrl,
    backgroundColor: palette.grey[100],
    imageFormat: 'WebP',
    imageSizeMultiplier: 2,
    params: [{
      width: imageWidth,
      quality: 90
    }]
  }) : undefined, [imageUrl, imageWidth, palette.grey]);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.Root, {
    href: url,
    "data-testid": getTestId(_common.BANNER_WRAPPER),
    type: type,
    children: [images ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.ImageWrapper, {
      ref: imageWrapperRef,
      imageWidth: imageWidth,
      shouldWidthBeLarger: shouldWidthBeLarger,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_LazyImage.LazyImage, {
        alt: imageUrl,
        imageRef: lazyImageRef,
        placeholderWidth: imageWidth,
        role: "img",
        srcSet: (0, _imageSizesHelper.generateSrcSet)(images),
        sizes: `${imageWidth}px`,
        testId: getTestId(_common.BANNER_IMAGE),
        onImageLoad: setLazyImageDimensions
      })
    }) : null, /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.ContentWrapper, {
      "data-testid": getTestId(_common.BANNER_CONTENT_WRAPPER),
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Content.Content, {
        ...props
      })
    }), url ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.LinkArrow, {
      "data-testid": getTestId(_common.BANNER_ARROW),
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_icons.ArrowRightThin, {})
    }) : null]
  });
};
exports.Banner = Banner;
